module.exports = __webpack_public_path__ + "static/media/actionsImg.f836ec7d.png";